import React, { useState } from "react";
import { Card, Row, Col, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import { CheckCircleFilled, EnvironmentOutlined } from "@ant-design/icons";
import { useStore } from "../../components/globalstate/GlobalState"

const { Title, Text } = Typography;

const locations = [
  { id: 1, name: "District 1", address: "Nguyen Hue, Ben Nghe Ward" },
  { id: 2, name: "District 3", address: "Vo Van Tan Street" },
  { id: 3, name: "District 5", address: "Tran Hung Dao Street" },
  { id: 4, name: "District 7", address: "Phu My Hung Area" },
  { id: 5, name: "Binh Thanh District", address: "Dien Bien Phu Street" },
];

const LocationPage = () => {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();
  const setLocation = useStore((state) => state.setLocation);

  const handleSelect = (loc) => {
    setSelected(loc.id);
    const fullLocation = `${loc.name} - ${loc.address}`;
    localStorage.setItem("selectedLocation", fullLocation);
    setLocation(fullLocation);
    message.success(`Selected: ${loc.name}`);
    setTimeout(() => navigate("/order-processing"), 700);
  };

  return (
    <div
      style={{
        padding: "60px 20px",
        minHeight: "100vh",
        background:
          "linear-gradient(160deg, #e6f0ff 0%, #ffffff 40%, #f5f7ff 100%)",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: 60 }}>
        <Title
          level={2}
          style={{
            color: "#002766",
            fontWeight: 700,
            letterSpacing: 0.6,
          }}
        >
          🏙️ Choose Your Location
        </Title>
        <Text type="secondary" style={{ fontSize: 16 }}>
          Select a nearby area to start your order
        </Text>
      </div>

      <Row gutter={[24, 24]} justify="center">
        {locations.map((loc) => {
          const isSelected = selected === loc.id;

          return (
            <Col xs={24} sm={12} md={8} lg={6} key={loc.id}>
              <Card
                hoverable
                onClick={() => handleSelect(loc)}
                style={{
                  border: isSelected ? "2px solid #1677ff" : "1px solid #f0f0f0",
                  borderRadius: 20,
                  boxShadow: isSelected
                    ? "0 12px 30px rgba(22, 119, 255, 0.25)"
                    : "0 6px 18px rgba(0,0,0,0.06)",
                  background: isSelected
                    ? "linear-gradient(145deg, #f0f7ff, #ffffff)"
                    : "linear-gradient(145deg, #ffffff, #fafafa)",
                  transition: "all 0.35s ease",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                }}
                bodyStyle={{
                  padding: "32px 26px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "translateY(-8px)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                {isSelected && (
                  <CheckCircleFilled
                    style={{
                      position: "absolute",
                      top: 14,
                      right: 14,
                      fontSize: 24,
                      color: "#1677ff",
                    }}
                  />
                )}

                <div
                  style={{
                    background: "#e6f4ff",
                    borderRadius: "50%",
                    width: 56,
                    height: 56,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 20,
                    boxShadow: "0 4px 10px rgba(22, 119, 255, 0.15)",
                  }}
                >
                  <EnvironmentOutlined
                    style={{ fontSize: 26, color: "#1677ff" }}
                  />
                </div>

                <Title
                  level={4}
                  style={{
                    marginBottom: 6,
                    color: "#001529",
                    fontWeight: 600,
                  }}
                >
                  {loc.name}
                </Title>
                <Text
                  type="secondary"
                  style={{
                    fontSize: 15,
                    lineHeight: 1.5,
                    display: "block",
                  }}
                >
                  {loc.address}
                </Text>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default LocationPage;
